import { api } from './client.js';

export const catalogs = {
  skills:     (q, category, limit) => api.get('/catalogs/skills',     { query: { q, category, limit } }),
  relatedSkills: (slug, limit = 12) =>
    api.get(`/catalogs/skills/${encodeURIComponent(slug)}/related`, { query: { limit } }),
  roles:      () => api.get('/catalogs/roles'),
  role:       (slug) => api.get(`/catalogs/roles/${encodeURIComponent(slug)}`),
  regions:    () => api.get('/catalogs/regions'),
  languages:      () => api.get('/catalogs/languages'),
  languageLevels: () => api.get('/catalogs/language-levels'),
  experience: () => api.get('/catalogs/experience'),
  employment: () => api.get('/catalogs/employment'),
};
